import { render, staticRenderFns } from "./PaginatedUserList.vue?vue&type=template&id=41adf1c6&"
import script from "./PaginatedUserList.vue?vue&type=script&lang=ts&"
export * from "./PaginatedUserList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports